import { render, staticRenderFns } from "./UploadMedia.vue?vue&type=template&id=2ab037c4&scoped=true"
import script from "./UploadMedia.vue?vue&type=script&lang=js"
export * from "./UploadMedia.vue?vue&type=script&lang=js"
import style0 from "./UploadMedia.vue?vue&type=style&index=0&id=2ab037c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab037c4",
  null
  
)

export default component.exports